import * as React from 'react';
import * as styles from './styles.css';

import { PopupArrow, Popup } from '@cian/popup-component';

import { FaqIcon } from '../FaqIcon';

export const InfoTooltip: React.FC = props => {
  return (
    <span className={styles['icon']}>
      <FaqIcon />
      <Popup arrow={PopupArrow.RIGHT} containerStyle={styles['popup']}>
        {props.children}
      </Popup>
    </span>
  );
};
